import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20minimalist%20studio%20flat%20lay%20photography%20featuring%20a%20carefully%20curated%20arrangement%20of%20trendy%20fashion%20sneakers%20and%20contemporary%20clothing%20accessories%20on%20a%20warm%20sand%20colored%20textured%20linen%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20large%20windows%2C%20editorial%20magazine%20style%2C%20clean%20and%20fresh%20aesthetic%2C%20gentle%20gradients%20in%20warm%20beige%20tones%2C%20high%20end%20product%20presentation%2C%20immaculate%20composition%20with%20intentional%20negative%20space&width=1600&height=900&seq=hero-v2-style-2026&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos selecionados e verificados"
          title="Hoobuy Spreadsheet Produtos Verificados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 pt-24 md:pt-28">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16 w-full">
          <div className="lg:w-[60%]">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-[1.05] tracking-tight">
              Hoobuy
              <br />
              Spreadsheet
              <br />
              <span className="text-accent-400">Atualizado 2026</span>
            </h1>
          </div>

          <div className="lg:w-[40%] flex flex-col gap-6">
            <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-md">
              Encontre produtos verificados, organizados em planilhas inteligentes (hoobuy spreadsheet), com links atualizados e seguros para compras na China.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-white border-2 border-white/60 rounded-full hover:bg-white hover:text-foreground-900 transition-all cursor-pointer whitespace-nowrap"
              >
                Acessar Planilha
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 pb-8 flex justify-center">
        <div className="animate-bounce w-10 h-10 flex items-center justify-center text-white/50">
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}